module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/place-e9096d761de0f7607d170f9ed4e890d1.svg&quot;;"